module.exports = __webpack_public_path__ + "img/paragraph.f27a1f8f.svg";